module.exports = __webpack_public_path__ + "static/media/guitar-1245856_1920.ec58acb9.jpg";